import { VoidChecks } from "../VoidChecks";
import { Button, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesProcessPrintChecks extends Layout {
    buttonGeneratePayments: Button;
    buttonViewPaymentRecords: Button;
    horizontalspacer2: HorizontalSpacer;
    labelInfoPrimary: Label;
    labelInfoSecondary: Label;
    layoutVoidChecks: VoidChecks;
    panelInfo: Panel;
    panelView: Panel;
    switchPrintChecksToImaging: Switch;
    textboxCheckNumber: Textbox;
}
